<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div *ngFor="let building of survey.buildings; let i = index">
      <app-inside-survey-photo-form *ngFor="let address of building.addresses; let j = index"
        [survey]="building.outsideSurvey" [address]="address" [buildingLamKey]="building.lamKey"
        [index]="i * survey.buildings.length + j" [buildingIndex]="i + 1" [addressIndex]="j + 1"
        [buildingKey]="building?.lomKey" [isAuthCanWrite]="isAuthCanWrite" [camera]="camera" [cameraLayer]="cameraLayer"
        [viewerLayer]="viewerLayer" [building]="building"></app-inside-survey-photo-form>
    </div>
  </div>
  <div class="open-all-btn-wrapper">
    <div *ngIf="showOpenButton$ | async; else collapseBtn" class="open-all-btn" (click)="openAllFrames()">
      <mat-icon>launch</mat-icon>
    </div>
    <ng-template #collapseBtn>
      <div class="open-all-btn" (click)="closeAllFrames()">
        <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
      </div>
    </ng-template>
  </div>
</div>